import React, { Component } from 'react'


import iconCustomize from './image/solution-customize.svg';
import iconEc from './image/solution-ec.svg';
import iconMeasure from './image/solution-measure.svg';
import iconSale from './image/solution-sale.svg';
import slogan from './image/slogan-solution.svg';
import banner from './image/banner-solution.svg';
import banner_mengduo from './image/mengduo/function.svg';
import './config'

import './Solution.css';

export default class Solution extends Component {
  constructor(props){
    super(props)
    this.state={
      data:[
        {
        title:'定制+智量',
        intro:'突破地理限制,延伸量体服务半径降低量体成本,节约30%量体成本净体尺寸,适用多品类定制的要求',
        img1:require('./image/dingzhi.svg'),
        },
        {
          title:'零售+智量',
          intro:'全新的门店智能量体终端充满科技感的量身定制体验线上线下全渠道服务顾客',
          img1:require('./image/lingshou.svg'),
        },
        {
          title:'电商+智量',
          intro:'高效获取海量用户精准身材数据精准匹配成衣尺码,自动推荐商品型号减少退换货比例,提高二次消费概率',
          img1:require('./image/dianshang.svg'),
        },
        {
          title:'体检+智量',
          intro:'完美适用于征兵、学生等体检工作快速、高效采集大批量人群身材数据自动生成电子表格,减少人工参与',
          img1:require('./image/solution-measure.svg'),
        }]
      }
    }
  

  

  render (){
    return(
     <div>
      {global.constants.isMobile&&
        <div>
          <div className="tag-container" style={{marginTop:"6rem"}}>
            {
              this.state.data.map((item,index)=>{
                return (
                  <div style={{borderBottom:(index===3?"0":"solid 0.01rem #c9c9c9")}} key={index} className="box" >
                    <img  src={item.img1} className="icon"/>
                    <div className="intro" style={{marginLeft:"1rem"}}>
                      <div className="title02-1">{item.title}</div>
                      <div className="intro02-1" style={{maxWidth:"18rem"}}>{item.intro}</div>
                    </div>
                  </div>  
                );
              })
            }
          </div>
        </div>
      }
      {!global.constants.isMobile&&
        <div>
          <div className={global.constants.channel==="mengduo"? "banner_mengduo":"banner"}>
            <div className="banner--content">
              <img src={slogan} alt="slogan" />
              <img src={global.constants.channel==="mengduo"? banner_mengduo:banner} alt="" />
            </div>
          </div>
          <div className="Solution--content content-area">
            <div className="Solution--item">
              <img
                src={iconCustomize}
                className="Solution--item__icon"
                alt=""
              />
              <div className="Solution--item__text">
                <p className="Solution--item__title">定制+智量</p>
                <p className="Solution--item__text">
                  随着人工智能的发展，在线量体成为定制行业发展的必然方向。【智量】面向定制行业提供的可定制化在线量体解决方案，可以帮助传统定制行业构建在线的量体服务平台，帮助企业用户提高获客效率、降低人力成本，赋予企业客户远距离自主量体的能力。同时，【智量】提供20余项净体数据，可以满足各个品类的定制需求。也可以根据客户量体标准，添加新的量体部位的数据。
                </p>
              </div>
            </div>
            <div className="Solution--item">
              <img
                src={iconSale}
                className="Solution--item__icon"
                alt=""
              />
              <div className="Solution--item__text">
                <p className="Solution--item__title">零售+智量</p>
                <p className="Solution--item__text">
                  【智量】同时提供软件、硬件的量体解决方案。通过计算机视觉技术实现线下商业场景中人、货、场的数据采集、统计和分析。提供客流统计、顾客识别、自动量体等功能的整体线下零售解决方案，提升零售坪效的同时，为数据化运营提供大数据支持。
                </p>
              </div>
            </div>
            <div className="Solution--item">
              <img
                src={iconEc}
                className="Solution--item__icon"
                alt=""
              />
              <div className="Solution--item__text">
                <p className="Solution--item__title">电商+智量</p>
                <p className="Solution--item__text">
                  随着电商发展趋势的放缓，如何精细化服务顾客，提高转化率已经成为所有电商平台面临的问题。引入便捷的私人尺码测量功能，可以为顾客推荐更为合身的尺码，不仅可以大幅降低因尺码不符，退换货的问题。而且科技提升平台用户粘性，形成独有的竞争力。
                </p>
              </div>
            </div>
            <div className="Solution--item">
              <img
                src={iconMeasure}
                className="Solution--item__icon"
                alt=""
              />
              <div className="Solution--item__text">
                <p className="Solution--item__title">体检+智量</p>
                <p className="Solution--item__text">
                  针对体检、体测的行业特点。【智量】可以在短时间内，为大批量的用户进行头围、胸围、腰围、臀围等举出数据的测量。系统测量的数据，可以按照要求的格式进行数据的导出，减少人工录入的工作量的同时，大幅提升体测的效率与准确度。通过【智量】硬件端，一次测量，即可提供体脂率、骨量、基础代谢等十余项健康指标。提供更多有价值的参考数据。
                </p>
              </div>
            </div>
          </div>
        </div>
      }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Solution.js